import { ShoppingBag } from "lucide-react";
import { useCart } from "../../contexts/CartContext";

export const FloatingCart = () => {
  const { count, setOpen } = useCart();
  if (!count) return null;
  return (
    <button
      data-testid="floating-cart"
      onClick={() => setOpen(true)}
      className="fixed bottom-40 right-4 z-[70] flex items-center gap-2 rounded-full bg-gradient-to-r from-[#F97316] to-[#22C55E] px-5 py-3.5 font-display text-sm font-bold text-[#09090B] shadow-[0_16px_50px_-10px_rgba(255,107,53,0.6)] transition-transform hover:scale-105"
    >
      <ShoppingBag className="h-4 w-4" />
      {count}
    </button>
  );
};
